import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export const LogoutPage: React.FC = () => {
  const navigate = useNavigate();
  const signOut = useAuthStore((state) => state.signOut);

  useEffect(() => {
    const performLogout = async () => {
      try {
        await signOut();
        navigate('/login', { replace: true });
      } catch (error) {
        console.error('Logout error:', error);
        // Even if there's an error, redirect to login
        navigate('/login', { replace: true });
      }
    };

    performLogout();
  }, [signOut, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Logging out...</p>
      </div>
    </div>
  );
};